import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Alert, Modal, ModalBody, ModalHeader, Spinner } from 'reactstrap';
import { Button, Col, Icon, Row, RSelect } from '../../../components/Component';
import TextInput from '../inputs/TextInput';
import countries from "../../../utils/countries.json";
import provinces from "../../../utils/provinces.json";
import districts from "../../../utils/districts.json";
import { tenant_auth_actions_helper } from '../../../actions/actions_helper';
import { fail_add_warehouse_site, loading_add_warehouse_site, reset_add_warehouse_site, success_add_warehouse_site } from '../../../reducers/auth_tenant/add_warehouse_site_Slice';
import { ADD_WAREHOUSE_SITE_ERROR_MSG, ADD_WAREHOUSE_SITE_SUCCESS_MSG } from '../../../utils/error_success_messages';
import { messageToast } from '../../../utils/Utils';
import { CREATE_WAREHOUSE_SITE_API } from '../../../api/api_data';
import { useSelector } from 'react-redux';
import * as app_consts from "../../../utils/app_consts";

const initalState = { name: "", type: "", address: "", country: "", province: "", district: "" };

const AddWarehouseSiteModal = ({
  openModal,
  setOpenModal,
  type,
  modalTitle,
  modalDescription,
  succFunc,
  size,
  accountId,
  openOtherModalFunc,
  tenant_info
}) => {
  const [modal, setModal] = useState(false);
  const [step, setStep] = useState(1);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(initalState);
  const [restructered_countries, setRestructuredCountries] = useState([]);
  const [restructred_provinces, setRestructuredProvinces] = useState([]);
  const [restructered_districts, setRestructuredDistricts] = useState([]);

  const dispatch = useDispatch();

  useEffect(() => {
    setError("");
    setFormData(initalState);
    setModal(openModal);

    const country_restruct = countries?.map((country) => {
      return { label: country, value: country };
    });

    setRestructuredCountries(country_restruct);

    const provinces_restruct = provinces.Zambia.map((province) => {
      return { label: province, value: province };
    });

    setRestructuredProvinces(provinces_restruct);

  }, [openModal]);

  const toggleModal = () => {
    setOpenModal(!modal);
  };
  // Handle Change Function
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const set_districts = (province) => {

    const districts_restruct = districts[province].map((district) => {
      return { label: district, value: district };
    });

    setRestructuredDistricts(districts_restruct);

  };

  const handleSubmit = () => {
    setError("");
    // Dispatch
    dispatch(tenant_auth_actions_helper(loading_add_warehouse_site, success_add_warehouse_site, fail_add_warehouse_site, ADD_WAREHOUSE_SITE_ERROR_MSG, ADD_WAREHOUSE_SITE_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${CREATE_WAREHOUSE_SITE_API}`, formData));
  };
  // Listen
  const add_warehouse_site_listener = useSelector((state) => state.add_warehouse_site.add_warehouse_site);

  useEffect(() => {
    if (add_warehouse_site_listener.status !== app_consts.IDLE)
    {
      if (add_warehouse_site_listener.status === app_consts.LOADING)
      {
        setLoading(true);
        setError("");
      } else
      {
        setLoading(false);
        if (add_warehouse_site_listener.status === app_consts.FAIL)
        {
          setError(add_warehouse_site_listener.message, app_consts.FAIL);
          messageToast(add_warehouse_site_listener.message, app_consts.FAIL);
        } else if (add_warehouse_site_listener.status === app_consts.SUCCESS)
        {
          succFunc();
          toggleModal();
        }
        dispatch(reset_add_warehouse_site());
      }
    }
  }, [add_warehouse_site_listener]);

  return (
    <>
      <Modal
        isOpen={modal}
        // toggle={!modalLoading ? toggleModal : ""}
        className="modal-dialog-centered"
        size={size ? size : "lg"}
      >
        <ModalHeader toggle={!loading ? toggleModal : ""}>{modalTitle}</ModalHeader>
        <ModalBody>
          <div className="d-flex justify-content-between mb-2">
            <h5 className="card-title text-center w-100">Add Warehouse Site Form</h5>
          </div>
          <form
            onSubmit={(e) => {
              e.preventDefault();
            }}
          >
            <Row className="g-4">
              <Col size={6}>
                <div className="form-group">
                  <label className="form-label mb-1 text-md" htmlFor="username">
                    Warehouse Type
                  </label>
                  <div className="form-control-wrap align-items-center w-100 d-flex flex-row mb-2 justify-between">
                    <div className="w-100">
                      <RSelect
                        options={[
                          {
                            label: "Physical", value: "physical"
                          },
                          {
                            label: "Virtual", value: "virtual"
                          },
                        ]
                        }
                        className="w-100"
                        placeholder="Search"
                        id="product_type_id"
                        onChange={(e) => {
                          setFormData({ ...formData, ["type"]: e.value });
                        }}
                      />
                    </div>
                  </div>
                </div>
              </Col>
              <TextInput
                label="Name"
                required
                type="text"
                id_val="name"
                maxlength="100"
                value={formData.name}
                colSize="6"
                name="name"
                handleChange={(e) => {
                  setFormData({ ...formData, ["name"]: e.target.value });
                }}
              />
              {
                formData.type === "physical" && (
                  <>
                    <TextInput
                      label="Physical Address"
                      required
                      type="text"
                      id_val="address"
                      maxlength="100"
                      value={formData.address}
                      colSize="6"
                      name="address"
                      handleChange={(e) => {
                        setFormData({ ...formData, ["address"]: e.target.value });
                      }}
                    />
                    <Col size={6}>
                      <div className="form-group">
                        <label className="form-label mb-1 text-md" htmlFor="country">
                          Country
                        </label>
                        <div className="form-control-wrap align-items-center w-100 d-flex flex-row mb-2 justify-between">
                          <div className="w-100">
                            <RSelect
                              options={restructered_countries}
                              className="w-100"
                              placeholder="Search"
                              id="country"
                              onChange={(e) => {
                                setFormData({ ...formData, ["country"]: e.value });
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </Col>
                    {
                      formData.country === 'Zambia' ? (
                        <Col size={6}>
                          <div className="form-group">
                            <label className="form-label mb-1 text-md" htmlFor="province">
                              Province
                            </label>
                            <div className="form-control-wrap align-items-center w-100 d-flex flex-row mb-2 justify-between">
                              <div className="w-100">
                                <RSelect
                                  options={restructred_provinces}
                                  className="w-100"
                                  placeholder="Search"
                                  id="province"
                                  onChange={(e) => {
                                    setFormData({ ...formData, ["province"]: e.value });
                                    set_districts(e.value);
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </Col>
                      ) : (

                        <TextInput
                          label="Province"
                          required
                          type="text"
                          id_val="province"
                          maxlength="100"
                          value={formData.province}
                          colSize="6"
                          name="province"
                          handleChange={(e) => {
                            setFormData({ ...formData, ["province"]: e.target.value });
                          }}
                        />
                      )
                    }
                    {
                      formData.country === 'Zambia' ? (
                        <Col size={6}>
                          <div className="form-group">
                            <label className="form-label mb-1 text-md" htmlFor="district">
                              District
                            </label>
                            <div className="form-control-wrap align-items-center w-100 d-flex flex-row mb-2 justify-between">
                              <div className="w-100">
                                <RSelect
                                  options={restructered_districts}
                                  className="w-100"
                                  placeholder="Search"
                                  id="district"
                                  onChange={(e) => {
                                    setFormData({ ...formData, ["district"]: e.value });
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </Col>
                      ) : (

                        <TextInput
                          label="District"
                          required
                          type="text"
                          id_val="district"
                          maxlength="100"
                          value={formData.district}
                          colSize="6"
                          name="district"
                          handleChange={(e) => {
                            setFormData({ ...formData, ["district"]: e.target.value });
                          }}
                        />
                      )
                    }
                  </>
                )}
            </Row>
            {error && (
              <div className="mb-3 w-100">
                <Alert color="danger" className="alert-icon">
                  <Icon name="alert-circle" /> {error}{" "}
                </Alert>
              </div>
            )}
            <Col xl="12" className="d-flex justify-content-end mt-2 mr-2">
              <Button onClick={handleSubmit} disabled={(loading || !formData.type) || formData?.type === "virtual" ? !(formData.name) : !(formData.country && formData.address && formData.district && formData.province && formData.name)} color="primary">
                {loading ? <Spinner size="sm" color="light" /> : "Add Warehouse Site"}
              </Button>
            </Col>
          </form>
        </ModalBody>
      </Modal>
    </>
  );
};

export default AddWarehouseSiteModal;